export default __webpack_public_path__ + "static/media/model3a.d4ec8af4.jpg";